import { render, staticRenderFns } from "./MessageInputComponent.vue?vue&type=template&id=9a2022a2&scoped=true"
import script from "./MessageInputComponent.vue?vue&type=script&lang=js"
export * from "./MessageInputComponent.vue?vue&type=script&lang=js"
import style0 from "./MessageInputComponent.vue?vue&type=style&index=0&id=9a2022a2&prod&lang=scss&scoped=true"
import style1 from "./MessageInputComponent.vue?vue&type=style&index=1&id=9a2022a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2022a2",
  null
  
)

export default component.exports